import { render } from "./KinescopePage.vue?vue&type=template&id=61b2d250&scoped=true"
import script from "./KinescopePage.vue?vue&type=script&lang=js"
export * from "./KinescopePage.vue?vue&type=script&lang=js"

import "./KinescopePage.vue?vue&type=style&index=0&id=61b2d250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b2d250"]])

export default __exports__